import { ProductTileChildComponent } from "@omni/types/components/product/enums/productTileChildComponent.enum";

const row = (row: Array<ProductTileChildComponent>) => (include: boolean) =>
    include ? [row] : [];

// cols[col[rows[...components]]
export const ProductTileLayout = {
    PLP: (buttons: boolean, categoryLink: boolean, compare: boolean) => [
        [
            [ProductTileChildComponent.ProductImage],
            ...row([ProductTileChildComponent.CategoryLink])(categoryLink),
            [
                ProductTileChildComponent.PromotionRibbon,
                ProductTileChildComponent.PriceSmall
            ],
            [ProductTileChildComponent.Title],
            [ProductTileChildComponent.DeliveryTypes],
            [ProductTileChildComponent.Features],
            [ProductTileChildComponent.Reviews],
            ...row([
                ProductTileChildComponent.Button,
                ProductTileChildComponent.WishlistButton
            ])(buttons),
            [ProductTileChildComponent.Stock],
            ...row([ProductTileChildComponent.Comparison])(compare)
        ]
    ],
    PLP_HORIZONTAL: (
        buttons: boolean,
        categoryLink: boolean,
        compare: boolean
    ) => [
        [
            [ProductTileChildComponent.ProductImage],
            [ProductTileChildComponent.PriceLarge],
            [ProductTileChildComponent.DeliveryTypes]
        ],
        [
            ...row([ProductTileChildComponent.CategoryLink])(categoryLink),
            [ProductTileChildComponent.Title],
            [ProductTileChildComponent.PromotionLabelSmall],
            [ProductTileChildComponent.Features],
            [ProductTileChildComponent.Reviews],
            ...row([
                ProductTileChildComponent.Button,
                ProductTileChildComponent.WishlistButton
            ])(buttons),
            [ProductTileChildComponent.Stock],
            ...row([ProductTileChildComponent.Comparison])(compare)
        ]
    ],
    AEM: (buttons: boolean, categoryLink: boolean) => [
        [
            [ProductTileChildComponent.ProductImage],
            ...row([ProductTileChildComponent.CategoryLink])(categoryLink),
            [
                ProductTileChildComponent.PromotionRibbon,
                ProductTileChildComponent.PriceMedium
            ],
            [ProductTileChildComponent.Title],
            [ProductTileChildComponent.Features],
            [ProductTileChildComponent.Reviews],
            ...row([
                ProductTileChildComponent.Button,
                ProductTileChildComponent.WishlistButton
            ])(buttons)
        ]
    ],
    WISHLIST: () => [
        [
            [ProductTileChildComponent.ProductImage],
            [
                ProductTileChildComponent.PromotionRibbon,
                ProductTileChildComponent.PriceSmall
            ],
            [ProductTileChildComponent.Title],
            [ProductTileChildComponent.Reviews],
            [
                ProductTileChildComponent.Button,
                ProductTileChildComponent.ExtraButtons,
                ProductTileChildComponent.WishlistButton
            ]
        ]
    ],
    WISHLIST_HORIZONTAL: () => [
        [[ProductTileChildComponent.ProductImage]],
        [
            [ProductTileChildComponent.Title],
            [
                ProductTileChildComponent.PromotionLabelSmall,
                ProductTileChildComponent.PriceMedium
            ],
            [ProductTileChildComponent.Reviews],
            [
                ProductTileChildComponent.Button,
                ProductTileChildComponent.ExtraButtons,
                ProductTileChildComponent.WishlistButton
            ]
        ]
    ],
    SEARCH: () => [
        [
            [ProductTileChildComponent.ProductImage],
            [ProductTileChildComponent.Title],
            [
                ProductTileChildComponent.PromotionLabelSmall,
                ProductTileChildComponent.PriceSmall
            ],
            [ProductTileChildComponent.Reviews]
        ]
    ],
    COMPARISON: () => [
        [
            [ProductTileChildComponent.ProductImage],
            [ProductTileChildComponent.Title],
            [
                ProductTileChildComponent.PromotionLabelSmall,
                ProductTileChildComponent.PriceSmall
            ],
            [ProductTileChildComponent.Reviews],
            [ProductTileChildComponent.Button]
        ]
    ],
    COMPARISON_BAR_HORIZONTAL: () => [
        [[ProductTileChildComponent.ProductImage]],
        [
            [ProductTileChildComponent.Title],
            [
                ProductTileChildComponent.PromotionLabelSmall,
                ProductTileChildComponent.PriceLarge
            ],
            [ProductTileChildComponent.Reviews]
        ]
    ],
    BUNDLE_VERTICAL: () => [
        [
            [ProductTileChildComponent.ProductImage],
            [ProductTileChildComponent.Title],
            [ProductTileChildComponent.PromotionLabelSmall],
            [ProductTileChildComponent.Reviews],
            [ProductTileChildComponent.Amount],
            [ProductTileChildComponent.PriceSmall]
        ]
    ],
    BUNDLE_HORIZONTAL: () => [
        [[ProductTileChildComponent.ProductImage]],
        [
            [ProductTileChildComponent.Title],
            [ProductTileChildComponent.PromotionLabelSmall],
            [ProductTileChildComponent.Reviews],
            [ProductTileChildComponent.PriceSmall],
            [ProductTileChildComponent.Amount]
        ]
    ],
    SLIDER: (button: boolean, categoryLink: boolean, features: boolean) => [
        [
            [ProductTileChildComponent.ProductImage],
            ...row([ProductTileChildComponent.CategoryLink])(categoryLink),
            [ProductTileChildComponent.Title],
            ...row([ProductTileChildComponent.Features])(features),
            [
                ProductTileChildComponent.PromotionLabelSmall,
                ProductTileChildComponent.PriceSmall
            ],
            [ProductTileChildComponent.Reviews],
            ...row([ProductTileChildComponent.Button])(button)
        ]
    ]
};
